module.exports = __webpack_public_path__ + "img/emoji_49.304c3520.png";